import React from "react";
import { BsTelephoneFill } from "react-icons/bs";
import { IoChatbubbleEllipses } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";

const Floating = () => {
  return (
    <div className="fixed bottom-6 right-4 z-50 flex flex-col items-end gap-3 group">
      
      {/* Floating Options */}
      <div className="flex flex-col gap-3 opacity-0 translate-y-4 pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto">
        
        <button className="w-12 h-12 rounded-full bg-white shadow-xl flex items-center justify-center hover:scale-105 transition-all">
          <BsTelephoneFill className="text-primary text-lg" />
        </button>

        <button className="w-12 h-12 rounded-full bg-white shadow-xl flex items-center justify-center hover:scale-105 transition-all">
          <IoChatbubbleEllipses className="text-primary text-xl" />
        </button>

        <button className="w-12 h-12 rounded-full bg-white shadow-xl flex items-center justify-center hover:scale-105 transition-all">
          <FaWhatsapp className="text-green-600 text-xl" />
        </button>
      </div>

      {/* Main Button */}
      <button className="w-16 h-16 rounded-full bg-gradient-to-r from-primary to-gradient2 shadow-2xl flex items-center justify-center hover:scale-105 transition-all">
        <img
          src={require("../../assets/bots.png")}
          alt="support"
          className="w-8 h-8 object-contain"
        />
      </button>
    </div>
  );
};

export default Floating;